export default __webpack_public_path__ + "static/sanjayRakesh6-13dd40b5c545a107f4d17bf5dec621c9.jpg";